<template>
  <el-dialog :title="ShipmentTitle" :visible.sync="ShipmentShow" width="480px" :top="top" @close="DialogSwitch">
    <div class="dialog_box">
      <div class="shipment-list">
        <el-table :data="ShipmentList" style="width: 100%;" height="300">
          <el-table-column prop="AreaName" :label="$t('enum.areaName')">
          </el-table-column>
          <el-table-column :label="$t('enum.price')">
            <!-- prop="Price"  -->
            <template slot-scope="scope">
              {{ scope.row.Status == 2 ? $t('newItem.payOnDelivery') : `USD ${scope.row.US_Price}` }}
              <!-- USD {{scope.row.US_Price}} -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="DialogSwitch">{{ $t('button.done') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogShipment',
  components: {},
  data() {
    return {
      ShipmentShow: false,
      ShipmentTitle: this.$t('enum.shippingFee'),
      applyHistory: [],
      list: [],
      top: '15vh',
      ID: 0,
    }
  },
  props: {
    ShipmentList: []
  },
  watch: {},
  created() {
    // console.log('dialog created');
  },

  mounted() {
  },
  methods: {
    // 调用tablelist组件的DialogSwitch方法(弹出物流详情)
    DialogSwitch() {
      this.$emit('DialogSwitch', 'DialogShipment');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog-shipment.vue